const CART_KEY = "cart";

/* El nombre de la clave lo necesita `useCart` para filtrar el evento
   `storage`, que llega por cualquier cosa que se guarde en el navegador y
   no solo por el carrito. Se exporta desde aca para que haya un solo
   lugar donde diga "cart". */
export { CART_KEY };

/* Un resumen corto del carrito, para comparar dos versiones sin recorrer
   objetos enteros. Lo usa el checkout para darse cuenta de que el carrito
   cambio en otra pestaña mientras el cliente llenaba el formulario. */
export const firmaCarrito = (cart) =>
  (Array.isArray(cart) ? cart : [])
    .map(
      (p) =>
        `${p.producto_id}:${p.cantidad}:${Math.round(
          Number(p.precio_unitario || 0) * 100
        )}:${Math.round(Number(p.core_charge || 0) * 100)}`
    )
    .sort()
    .join("|");

const normalizeItem = (item) => ({
  producto_id: item.producto_id,
  nombre: item.nombre ?? item.nombre_producto ?? "",
  precio_unitario: Number(item.precio_unitario),

  core_charge: Number(item.core_charge || 0),

  imagen: item.imagen,
  cantidad: item.cantidad,
  stock: item.stock,
});

export const getCart = () => {
  const data = localStorage.getItem(CART_KEY);
  if (!data) return [];

  const cart = JSON.parse(data);

  return cart.map((item) =>
    normalizeItem({
      ...item,
      cantidad: Math.min(Math.max(1, item.cantidad), item.stock ?? item.cantidad),
    })
  );
};

export const saveCart = (cart) => {
  localStorage.setItem(CART_KEY, JSON.stringify(cart));
};

export const addToCart = (product, cantidad = 1) => {
  const cart = getCart();
  const index = cart.findIndex((p) => p.producto_id === product.producto_id);
  const stock = Number(product.cantidad_disponible || 0);
  const core_charge = Number(product.core_charge || 0);

  if (index >= 0) {
    cart[index].cantidad = Math.min(cart[index].cantidad + cantidad, stock);
    cart[index].core_charge = core_charge;
  } else {
    cart.push(
      normalizeItem({
        producto_id: product.producto_id,
        nombre: product.nombre_producto || product.nombre,
        precio_unitario: Number(product.precio_unitario),
        core_charge,
        imagen: product.url_image,
        cantidad: Math.min(cantidad, stock),
        stock,
      })
    );
  }

  saveCart(cart);
  return cart;
};

export const updateCartQty = (producto_id, cantidad) => {
  let cart = getCart();

  cart = cart.map((p) =>
    p.producto_id === producto_id
      ? normalizeItem({
          ...p,
          cantidad: Math.min(Math.max(1, cantidad), p.stock),
        })
      : p
  );

  saveCart(cart);
  return cart;
};

export const removeFromCart = (producto_id) => {
  let cart = getCart();
  cart = cart.filter((p) => p.producto_id !== producto_id);
  saveCart(cart);
  return cart;
};

export const clearCart = () => {
  localStorage.removeItem(CART_KEY);
};
